export const RESERVATIONS_COLLECTION = 'reservations';
